/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
import { useMemo } from 'react';

import { useNavigate } from 'react-router-dom';
import { Button } from 'ui/components/common';
import { useAppWrapperContext } from 'ui/layouts/AppWrapper';
import { useAdminParams } from 'utils/helpers';
import { Notification } from 'utils/types';

const ChannelDescription = {
  SMS: (_n?: Notification) => 'New message received.',
};

const ChannelLogs = {
  SMS: {
    title: 'Inbox',
    description: (_n?: Notification) => ChannelDescription.SMS(_n),
    element: ({ meta }: Notification) => {
      const navigate = useNavigate();

      const {
        state: { isPreview },
      } = useAppWrapperContext();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(
        () =>
          isPreview
            ? // eslint-disable-next-line max-len
              `/preview/accounts/${accountId}/users/${accountUserId}/inbox?type=sms&number=${meta?.from}`
            : `/inbox?type=sms&number=${meta?.from}`,
        [accountId, accountUserId, isPreview, meta?.from],
      );

      const sms = useMemo(() => meta?.body ?? '', [meta]);
      const sender = useMemo(() => {
        if (meta?.fromId) {
          return (
            <>
              {meta?.fromId?.fullName}{' '}
              <span className="font-xs italic font-thin">({meta?.from})</span>
            </>
          );
        }

        return meta?.from;
      }, [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {sender}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <p className="line-clamp-2">{sms}</p>
          </div>
          <Button
            label="View Message"
            onClick={() => navigate(link)}
            intent="link"
            className="p-0"
          />
        </>
      );
    },
  },
};

export default ChannelLogs;
